import { Identite } from '../../../identite/shared/classes/identite';

export class Agence {
    id: string;
    ref: string;
    roles_id: string;
    identite: Identite;
    mw_uuid: string;


    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id                 = data['id'] ? data['id'] : null;
        this.ref                = data['ref'] ? data['ref'] : null;
        this.roles_id           = data['roles_id'] ? data['roles_id'] : null;
        this.identite           = data['identite'] ? new Identite(data['identite']) : new Identite();
        this.mw_uuid            = data['mw_uuid'] ? data['mw_uuid'] : null;
    }
}
